<template>
  <div class="bb-sign-in">
    <h1 class="bb-sign-in__title">
      Business Boutique Group
    </h1>
    <div class="bb-sign-in-modal">
      <transition name="fade" appear>
        <loader-fly v-if="loaderRun"></loader-fly>
      </transition>
      <div class="bb-sign-in-modal-row">
        <div class="bb-sign-in-modal__img">
          <img src="../../../assets/images/signin.jpg" alt="">
        </div>
        <div class="bb-sign-in-modal__form">
          <h2 class="bb-sign-in-modal__title">Sign In</h2>
          <div
            class="bb-sign-in-button-google"
            @click="handleClickLogin"
          >
            <div v-html="GoogleIcon()"/>
            Continue with Google
          </div>
        </div>
      </div>
    </div>
    <div class="bb-sign-in-copyright">
      Copyright &copy; {{year}} Business Boutique Group
    </div>
  </div>
</template>

<script>
// import signInApi from '../../../api/SignIn/api'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import LoaderFly from '../Loaders/LoaderFly'
import {FOUNDER} from '@/constants/roles'
import { GoogleIcon } from '@/constants/icon'
import { SIDE_HOURLY } from '@/constants/projectTypes'
import { IN_PROGRESS_PROJECT } from '@/constants/projectStatuses'
import CompaniesApi from '@/api/Companies/api'
import _ from 'lodash'
import TimerApi from '@/api/Timer/api'
import GmailApi from '@/api/Gmail/api'
import UserApi from '@/api/User/api'
import ProjectListApi from '@/api/ProjectsList/api'
import getGmailTokens from '@/mixin/getGmailTokens'
import setWatchGoogle from '@/mixin/setWatchGoogle'
import {FAIL_STATUS_AUTH_USER} from '@/constants/googleApi/statusAuthUserServer'
import {DOMAINS} from '@/constants/domainListPlatform'

export default {
  name: 'SignIn',
  components: {
    ValidationProvider,
    ValidationObserver,
    LoaderFly
  },
  mixins: [getGmailTokens, setWatchGoogle],
  data () {
    return {
      user: {
        email: '',
        password: ''
      },
      loaderRun: false,
      errors: {
        email: '',
        password: '',
        login: ''
      },
      GoogleIcon
    }
  },
  computed: {
    currentDomain: {
      get: function () {
        return this.$store.getters.currentDomain
      },
      set: function (data) {
        this.$store.dispatch('setCurrentDomain', data)
      }
    },
    windowAuthPopup: {
      get: function () {
        return this.$store.getters.windowAuthPopup
      },
      set: function (data) {
        this.$store.dispatch('setWindowAuthPopup', data)
      }
    },
    year: function () {
      return new Date().getFullYear()
    },
    userInfo: {
      get: function () {
        return this.$store.getters.userInfo
      },
      set: function (data) {
        this.$store.dispatch('setUserInfo', data)
      }
    },
    companiesList: {
      get: function () {
        return this.$store.getters.companiesList
      },
      set: function (data) {
        this.$store.dispatch('setCompaniesList', data)
      }
    },
    activeCompany: {
      get: function () {
        return this.$store.getters.activeCompany
      },
      set: function (data) {
        this.$store.dispatch('setActiveCompany', data)
      }
    },
    isShowTimerPanel: {
      get () {
        return this.$store.getters.isShowTimerPanel
      },
      set (data) {
        this.$store.dispatch('setShowTimer', data)
      }
    },
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    time: {
      get () {
        return this.$store.getters.time
      },
      set (data) {
        this.$store.dispatch('setTimer', data)
      }
    }
  },
  methods: {
    addToWindow () {
      this.getByToken()
    },
    async handleClickLogin () {
      window.addToWindow = this.addToWindow
      const { id } = this.currentDomain
      try {
        const { data } = await GmailApi.gmailActionsAuth({domain: id})
        const { innerHeight, innerWidth } = window
        const left = (innerWidth / 2) - (470 / 2)
        const height = innerHeight < 860 ? 500 : innerHeight * 0.6
        const top = (innerHeight / 2) - (height / 2)
        const style = `width=470, height=${height}, top=${top}, left=${left},status=no,toolbar=no,menubar=no`
        window.open(
          data,
          'displayWindow',
          style
        )
      } catch (err) {
        console.error(err)
      }
    },
    async getByToken () {
      try {
        const { data: {ip, country, country_code} } = await UserApi.getUserLocation();
        const { data } = await GmailApi.getByToken(ip, country, country_code)
        const { token } = data
        this.$cookie.set('token', token)
        this.userInfo = data
        // this.userInfo.firework = this.$cookie.get('firework') !== 'true' // for firework
        if (!this.$cookie.get('company')) {
          this.activeCompany = data.company
          this.$cookie.set('company', this.userInfo.company)
        } else {
          this.activeCompany = this.$cookie.get('company')
        }
        this.getCompanyById()
        if (data.role === FOUNDER.id) {
          this.getCompany()
        }
        this.loaderRun = false
        this.getActiveTimer()
        this.$router.push({name: 'Dashboard'})
      } catch (err) {
        console.error(err)
      }
    },
    validateForm () {
      let haveError = false
      if (!this.user.email) {
        this.errors.email = 'mandatory field'
        haveError = true
      } else {
        this.errors.email = ''
        haveError = false
      }
      if (!this.user.password) {
        this.errors.password = 'mandatory field'
        haveError = true
      } else {
        this.errors.password = ''
        haveError = false
      }
      return haveError
    },
    errorsCheck (errObj) {
      const errors = _.get(errObj, 'response.data.errors', '')
      const firstErr = Object.keys(errors)[0]
      if (errors[firstErr]) {
        this.errors.login = firstErr + ' ' + errors[firstErr]
      }
    },
    getCompany () {
      this.loaderRun = true
      CompaniesApi.getCompanies()
        .then((resp) => {
          this.companiesList = resp.data.companies
          if (_.findIndex(this.companiesList, {id: this.activeCompany}) < 0 && this.companiesList.length > 0) {
            this.activeCompany = this.companiesList[0].id
            this.$cookie.set('company', this.companiesList[0].id)
          }
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getCompanyById () {
      CompaniesApi.getCompaniesById(this.activeCompany)
        .then(({data}) => {
          this.$store.dispatch('setCurrentCompany', data)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    async getActiveTimer () {
      const { id } = this.userInfo
      try {
        const { data } = await TimerApi.getActiveTimer(id)
        this.isShowTimerPanel = !!data.length
        if (!data.length) return
        const [ item = {} ] = data
        const { subTimers = {} } = item
        const { companies = [{}], project = [], request = [], instanceStatus } = subTimers
        const [ parentProject = {}, subProject = {} ] = project
        const [ requestProject = {} ] = request
        const { _id, client } = parentProject

        this.activeTimer = {
          ...item,
          project: _id,
          requestProject: requestProject._id,
          subprojectId: subProject._id,
          instanceStatus,
          client,
          subTimers: {
            ...subTimers,
            companies: companies.length ? companies : [{}]
          }
        }
        this.time.isFirst = true
        this.getSubProjects()
      } catch (err) {
        console.error(err)
      }
    },
    async getSubProjects () {
      const { project, subprojectId } = this.activeTimer
      if (!subprojectId) return
      try {
        const { data } = await ProjectListApi.getProjects({
          parentProjectId: project,
          projectType: SIDE_HOURLY.id,
          status: IN_PROGRESS_PROJECT.id
        })
        const { projects = [] } = data
        projects.forEach((el) => {
          el.id = el._id
        })
        this.activeTimer.subProjectsList = projects
      } catch (err) {
        console.error(err)
      }
    },
    checkDomainPlatform () {
      const { location = {} } = window
      const { href } = location
      const currentItem = DOMAINS.find((el) => {
        const { name } = el
        return href.includes(name)
      })
      this.currentDomain = currentItem
    }
  },
  watch: {
    windowAuthPopup (newVal) {
      if (newVal.status === FAIL_STATUS_AUTH_USER) this.errors.email = FAIL_STATUS_AUTH_USER
    }
  },
  beforeMount () {
    const { location = {} } = window
    const { hash } = location
    if (hash === '#authGoogle') {
      window.opener.addToWindow()
      window.close()
    }
    this.checkDomainPlatform()
  }
}
</script>

<style lang="scss" scoped>

  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-sign-in {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: $color-accent-hover;

    &:before {
      content: '';
      position: absolute;
      z-index: 0;
      width: 100%;
      height: 100%;
      background: url(../../../assets/images/signin-background.jpg);
      background-size: cover;
      opacity: 0.05;
    }
    &__title {
      @include global-font;
      font-style: normal;
      font-weight: 600;
      font-size: 39px;
      line-height: 137.75%;
      color: $color-white;
      margin-bottom: 85px;
    }

    &-copyright {
      @include global-font;
      font-size: 15px;
      line-height: 18px;
      color: $color-white;
      display: flex;
      margin-top: auto;
      position: absolute;
      bottom: 20px;
    }

    &-modal {
      background: $color-white;
      box-shadow: 0 4px 15px rgba($color-black, 0.05);
      border-radius: 16px;
      max-width: 730px;
      width: 100%;
      padding: 60px 28px 57px 28px;
      margin-bottom: 100px;
      position: relative;
      z-index: 1;

      &__form {
        display: flex;
        align-items: center;
        flex-direction: column;
        max-width: 266px;
        width: 100%;
        position: relative;
        margin-top: 51px;
      }

      &__label {
        position: relative;
        display: block;

        i {
          position: absolute;
          right: 0;
          bottom: 7px;
          color: $color-red-orange;
        }
      }

      &__img {
        width: 378px;

        img {
          max-width: 100%;
          height: auto;
        }
      }

      &__title {
        @include global-font;
        font-size: 18px;
        line-height: 21px;
        color: $color-mariner;
        margin-bottom: 27px;
      }

      &__btn {
        padding: 0 97px;
        margin-top: 24px;

        &:hover {
          background-color: $color-cerise;
        }

        &:active {
          background-color: $color-accent;
        }
      }

      &__input {
        height: 30px;
        color: $color-text;
        margin-bottom: 26px;
        display: block;
        width: 100%;

        &_error {
          border-bottom: 1px solid $color-red-orange;
        }

        &:focus {
          border-bottom: 1px solid $color-accent;
        }
      }

      &-row {
        display: flex;
        grid-gap: 0 17px;
      }

      &__error-text {
        @include global-font;
        position: absolute;
        bottom: -30px;
        width: 100%;
        color: $color-red-orange;
        font-size: 12px;
        line-height: 14px;
        border: none;
        text-align: center;
        background-color: $color-white;
      }
    }
    .bb-loader-background {
      border-radius: 16px;
    }

    .bb-sign-in-button-google {
      display: flex;
      align-items: center;
      justify-content: center;
      grid-gap: 0 10px;
      @include global-font;
      font-size: 16px;
      line-height: 19px;
      color: $color-black;
      width: 100%;
      padding: 12px 0;
      border: 1px solid #DBEBF6;
      border-radius: 4px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/SignIn/SignIn.vue